import React from "react"
import styled from "styled-components"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import Particles from "react-particles-js"
import { StyledButton } from "../components/Button"
import particlesConfig from "../styles/particlesjs-config-hero.json"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"

const StyledNavButton = styled(StyledButton)`
  width: calc(100% - 32px);
  transform: translateX(16px);
  padding: 15px 0;
  font-size: 20px;
  letter-spacing: 2px;
  display: block;
  position: absolute;
  z-index: 20;
  bottom: 16px;
  left: 0;
  font-family: "Made Bold", sans-serif;
  text-decoration: none;
  &:hover {
    transform: scale(1.06) translateX(16px);
  }
`

const BackgroundDiv = styled.div`
  width: 100vw;
  min-height: -webkit-fill-available;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  flex-direction: column;
  position: relative;
`

const StyledLink = styled(AniLink)`
  font-family: "Made Evo Bold";
  text-decoration: none;
  transition: 0.2s ease;
  margin-bottom: 30px;
  color: rgb(255, 255, 255);
  font-size: 24px;
  letter-spacing: 0.3px;
  display: block;
  text-align: center;
  text-decoration: none;
  position: relative;
  z-index: 20;
`

const MobileNav = () => {
  return (
    <Layout hideFooter>
      <SEO noIndex title="Nawigacja" canonical="/mobile-nav" />
      <BackgroundDiv>
        <Particles
          params={particlesConfig}
          style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
        />
        <StyledLink cover to="/" bg="#474dc4" duration={0.9}>
          Strona główna
        </StyledLink>
        <StyledLink as="a" href="/#realizacje">
          Realizacje
        </StyledLink>
        <StyledLink cover bg="#474dc4" to="/o-nas/" duration={0.9}>
          O nas
        </StyledLink>
        <StyledLink cover to="/blog" bg="#474dc4" duration={0.9}>
          Blog
        </StyledLink>
        <StyledNavButton as="a" href="/#kontakt">
          ZATRUDNIJ NAS
        </StyledNavButton>
      </BackgroundDiv>
    </Layout>
  )
}

export default MobileNav
